/**
 * API请求工具函数
 */
import apiClient from '@/api/adapter'

/**
 * 处理API响应
 * @param {Promise} promise - API请求Promise
 * @param {Object} options - 配置选项
 * @returns {Promise}
 */
export function handleApiResponse(promise, options = {}) {
  const {
    showLoading = false,
    showError = true,
    showSuccess = false,
    successMessage = '操作成功',
    errorMessage = null,
    loadingText = '加载中...',
    vm = null
  } = options

  let loadingInstance = null
  if (showLoading && vm) {
    loadingInstance = vm.$loading({
      lock: true,
      text: loadingText,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }

  return promise
    .then(response => {
      if (loadingInstance) {
        loadingInstance.close()
      }

      if (response.data && response.data.status === 200) {
        if (showSuccess && vm) {
          vm.$message && vm.$message({
            message: successMessage,
            type: 'success'
          })
        }
        return response.data
      } else {
        const errorMsg = response.data?.error || response.data?.message || errorMessage || '操作失败'
        if (showError && vm) {
          vm.$message && vm.$message({
            message: errorMsg,
            type: 'error'
          })
        }
        return Promise.reject(new Error(errorMsg))
      }
    })
    .catch(error => {
      if (loadingInstance) {
        loadingInstance.close()
      }

      // 401错误已在adapter.js中处理，这里不需要重复处理
      if (error.response && error.response.status === 401) {
        // 已经在 adapter.js 中处理了跳转，这里不需要额外操作
        return Promise.reject(error)
      }

      const errorMsg = error.response?.data?.error || 
                      error.response?.data?.message || 
                      error.message || 
                      errorMessage || 
                      '请求失败'
      
      if (showError && vm) {
        vm.$message && vm.$message({
          message: errorMsg,
          type: 'error'
        })
      }

      return Promise.reject(error)
    })
}

/**
 * GET请求
 * @param {string} url - 请求URL
 * @param {Object} config - axios配置
 * @param {Object} options - 处理选项
 * @returns {Promise}
 */
export function apiGet(url, config = {}, options = {}) {
  const promise = apiClient.get(url, config)
  return handleApiResponse(promise, options)
}

/**
 * POST请求
 * @param {string} url - 请求URL
 * @param {Object} data - 请求数据
 * @param {Object} config - axios配置
 * @param {Object} options - 处理选项
 * @returns {Promise}
 */
export function apiPost(url, data = {}, config = {}, options = {}) {
  const promise = apiClient.post(url, data, config)
  return handleApiResponse(promise, options)
}

/**
 * PUT请求
 * @param {string} url - 请求URL
 * @param {Object} data - 请求数据
 * @param {Object} config - axios配置
 * @param {Object} options - 处理选项
 * @returns {Promise}
 */
export function apiPut(url, data = {}, config = {}, options = {}) {
  const promise = apiClient.put(url, data, config)
  return handleApiResponse(promise, options)
}

/**
 * DELETE请求
 * @param {string} url - 请求URL
 * @param {Object} config - axios配置
 * @param {Object} options - 处理选项
 * @returns {Promise}
 */
export function apiDelete(url, config = {}, options = {}) {
  const promise = apiClient.delete(url, config)
  return handleApiResponse(promise, options)
}

